import { Reveal, Overline, CTA } from "./primitives";
import { ENROLL_URL } from "../../config";

const possibilities = [
  "A business",
  "Selling your art",
  "Consulting",
  "Traveling",
  "Paying off debt",
  "Having enough that unexpected expenses don't feel like emergencies",
  "Working because you want to, not because you have to",
];

export const Collage = () => (
  <section id="create" data-testid="create-section" className="relative overflow-hidden bg-alabaster py-28 md:py-40">
    <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-20">
      <div className="lg:col-span-6">
        <Reveal><Overline>Now · About You</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            What could <span className="italic text-terracotta">you</span> create when you stop doubting yourself?
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="mt-8 max-w-md space-y-3">
            {possibilities.map((p) => (
              <li key={p} className="flex items-baseline gap-3 font-sans text-lg font-light text-stonegray">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
                {p}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 font-display text-2xl italic text-ink md:text-3xl">
            Whatever it looks like, it should belong to you.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-md font-sans text-base font-light leading-relaxed text-stonegray">
            As you picture that version of you making calm, powerful money decisions, notice how right it already
            feels in your body.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <div className="mt-10"><CTA href={ENROLL_URL} data-testid="create-cta">I'm ready for more</CTA></div>
        </Reveal>
      </div>

      <Reveal className="lg:col-span-6" y={50}>
        <div className="relative">
          <div className="glow-float absolute -inset-6 -z-10 rounded-full bg-terracotta/25 blur-3xl" />
          <img
            src="/images/making-it-rain.jpg"
            alt="Your version of a wealthy life"
            data-testid="create-image"
            loading="lazy"
            className="aspect-[4/5] w-full rounded-[2px] object-cover"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
